import {currentTenant} from '../tenant/tenant-context.js';

// Property access is lazy (resolved per-access, not at import time) so this
// module works whether it's evaluated once per Node process (SSR, shared
// across concurrent tenants) or once per browser tab (client).
export default new Proxy({}, {
    get: (_, key) => currentTenant()?.messages?.[key],
});

